import type { ProjectDetailsResource } from '../../types.tsx';
import type { ProjectDetailsResponse, ProjectNode } from './types.tsx';

const mapProjectNode = (node?: ProjectNode | null) => {
	if (node == null) {
		return null;
	}

	return {
		key: node.key,
		id: Number(node.projectId),
		avatarUrl: node.avatar?.large ?? '',
		name: node.name,
		type: node.projectType.toLowerCase(),
		isSimplified: node.simplified,
		isFavorite: node.favorite === true,
		permissions: {
			administerProject: node.administerProject.canPerform,
			createIssues: node.createIssues.canPerform,
			viewIssues: node.viewIssues.canPerform,
		},
	};
};

export const transformData = (
	data: ProjectDetailsResponse['data'] | null,
	projectIdOrKey: string,
): ProjectDetailsResource => ({
	currentProject:
		mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ??
		mapProjectNode(data?.jwmSidebar?.jiraProjectById) ??
		null,
	projectIdOrKey,
});
